export default __webpack_public_path__ + "static/media/blog-post-layout-04-img-07.9b496a88.jpg";